export const all_routes = {
  dealsDashboard: "/dashboard/deals-dashboard",
  dashboard: "/dashboard",
  linkusClient: "/linkus-client",
  agentLinkusClient: "/agent/linkus-client",
  scriptGenerator: "/script-generator",
  adminDashboard: "/admin/companies-list",
  contactDetails: "/crm/customer-details",
  agentContactDetails: "/agent/crm/customer-details",
  companyDetails: "/crm/company-details",
  deals: "/crm/deals",
  dealsDetails: "/crm/deals-details",
  dealsKanban: "/crm/deals-kanban",
  contactList: "/crm/customer-list",
  agentContactList: "/agent/crm/customer-list",
  leadsKanban: "/leads-kanban",
  pipeline: "/crm/pipeline",
  contactFaq: "/crm/contactFaq",
  dialer:"/dialer",
  agentDialer:"/agent/dialer",
  allCalls: "/crm/speakToLead/allCalls",
  api: "/crm/api",
  security: "/crm/setting/security",
  agentSecurity: "/agent/crm/setting/security",
  adminSecurity: "/admin/crm/setting/security",
   templates: "/templates",
  callAndRecording: "/agent/crm/call-logs-and-recordings",
  agentCallAndRecording: "/agent/crm/agent-call-logs-and-recordings",
  syncAndIntegration: "/crm/sync-and-integration",
  importAndExport: "/crm/import-and-export",
  agentImportAndExport: "/agent/crm/import-and-export",
  helpAndSupport: "/crm/help-and-support",
  agentHelpAndSupport: "/agent/crm/help-and-support",
  myTickets: "/crm/help-and-support/myTickets",
  myTicketsAgent: "/agent/crm/help-and-support/myTickets",
  upgradePlan: "/crm/upgradePlan",
  calendar: "/crm/calendar",
  agentCalendar: "/agent/crm/calendar",
  agentDashboard: "/agent/dashboard",
  contactGrid: "/crm/customer-kanban",
  leadsDetails: "/leads-details",
  agentLeadsDetails: "/agent/leads-details",
  contact_statuses: "/contact-statuses",
  leads: "/leads",
  agentFaq: "/agent/contactFaq",
  agentLeads: "/agent/leads",
  Whatsapp: "/crm/Whatsapp",
  register: "/register",
  linkLogin: "/link-login",
  forgotPassword: "/forgot-password",
  userVerification: "/user-verification",
  agentSetup: "/agent-setup",
  resetPassword: "/reset-password",
  profile: "/crm/settings/profile",
  agentProfile: "/agent/settings/profile",
  adminProfile: "/admin/settings/profile",
  agents: "/agents",
  contactReports: "/reports/contact-reports",

  adminCompaniesList: "/admin/companies-list",
  manageTickets: "/admin/manage-tickets",
};
